require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-centers-marco-dominguez-awarded-civil-rights-chamion.json") })
        }
      }, "path---articles-financial-centers-marco-dominguez-awarded-civil-rights-chamion");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-centers-marco-dominguez-awarded-civil-rights-chamion!./.cache/json/articles-financial-centers-marco-dominguez-awarded-civil-rights-chamion.json
// module id = 1675
// module chunks = 231608221292675